import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.5 12.004a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.078 1.41-.513m14.095-5.13 1.41-.513M5.106 17.79l1.15-.965m11.49-9.641 1.149-.965M7.501 19.8l.75-1.3m7.5-12.99.75-1.299m-6.063 16.658.26-1.477M13.303 4.62l.26-1.478m0 17.727-.26-1.477M10.698 4.619l-.26-1.478M16.5 19.8l-.75-1.3M7.5 4.21l4.5 7.794m6.894 5.785-1.149-.964M6.256 7.183l-1.15-.964m15.352 8.863-1.41-.513M4.954 9.44l-1.41-.513m8.458 3.078L8.252 18.5"
    }, null, -1)
  ])))
}
export default { render: render }